import * as Icons from '@ant-design/icons';
import { FieldsetTitle } from 'components/professor_area/FieldsetTitle';
import { Skeleton, Table } from 'antd';
import { useCertificateStore } from '../../certificate.store';
import { TagField, TextField, useTable } from '@refinedev/antd';
import { useMemo } from 'react';
import { CrudFilter, useCustom, useList, useOne } from '@refinedev/core';
import { formatDate } from 'services/date';

interface IEnrollmentChangeLog {
  id: string;
  versions: {
    attribute_fields: [];
    author: {
      id: string;
      personal_info: {
        document_info: string;
        document_type: string;
        full_name: string;
        phone_number: string;
      };
      name: string;
      created_at: string;
      event: string;
      item_type: string;
    };
  }[];
}

export const TabEditionHistory = () => {
  const { enrollment } = useCertificateStore();

  const { data, isLoading } = useCustom<IEnrollmentChangeLog>({
    url: `/admin/graduate/courses/enrollments_for_certification/change_logs`,
    method: 'get',
    config: {
      filters: [
        {
          field: 'enrollment_id',
          operator: 'eq',
          value: enrollment?.id
        }
      ]
    },
    queryOptions: {
      enabled: !!enrollment?.id
    }
  });

  const dataSource: IEnrollmentChangeLog['versions'] = useMemo(() => {
    if (!data?.data?.versions) return [];

    return data?.data.versions;
  }, [data?.data]);

  if (isLoading) return <Skeleton active />;

  return (
    <>
      <FieldsetTitle
        title="Histórico de edições"
        icon={Icons.FileDoneOutlined}
        hint="Veja as últimas atualizações realizadas"
      />
      <Table dataSource={dataSource}>
        <Table.Column
          title="Autor"
          dataIndex={['author', 'name']}
          key="author"
        />
        <Table.Column
          title="Editado em"
          dataIndex="item_type"
          key="item_type"
          render={value => (
            <TagField
              value={
                value.toLowerCase() === 'document'
                  ? 'Documentação'
                  : 'Dados do usuário'
              }
            />
          )}
        />
        <Table.Column
          title="Data da edição"
          dataIndex="created_at"
          key="created_at"
          render={value => (
            <TextField value={formatDate(value, 'DD/MM/YYYY - HH:mm')} />
          )}
          width={200}
        />
      </Table>
    </>
  );
};
